import { Divider } from "antd";
import type { FC } from "react";

import { OrganisationUnitsTree } from "src/app/features/OrganisationUnitsTree/components/trees/OrganisationUnitsTree";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";

export const OrganisationUnitsTreePage: FC<NoneOwnProps> = () => {
    const hasAccess = canAccess(ResourceName.SITES, "tree");

    return (
        <PageLayout>
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.organisationUnitsTree" />
                    <Divider />
                    <OrganisationUnitsTree />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
